import React from "react";
import { filterRoutes } from "@/utils/featureFlipDependepent";
import CompanyInvoices from "@pages/business/invoices/CompanyInvoices";
import InvoiceDetails from "@pages/business/invoices/InvoiceDetails";
import PaymentPage from "@pages/business/invoices/PaymentPage";
import BIAnalysisPage from "@pages/bi_b2b";
import { taleScanProblems } from "@pages/survey/new/tale-scan/taleScanProblems";

const AISurvey = React.lazy(() => import("@pages/survey/new/ai/index"));
const CreateSurveyFromScratch = React.lazy(() =>
    import("@pages/survey/new/scratch/index")
);
const SurveyCreationMethod = React.lazy(() =>
    import("@pages/survey/new/index")
);
const SurveyAnalyticsPage  = React.lazy(() =>
    import("@pages/survey/surveyId/SurveyAnalyticsPage")
);
// const CreateSimpleSurvey = React.lazy(() =>
//   import("@pages/survey/new/simple/index")
// );
const Reports = React.lazy(() =>
    import("@pages/reports")
);
const FocusGroupNew = React.lazy(() =>
    import("@pages/focus-group/focusGroup/new")
);
const FocusGroupParticipants = React.lazy(() =>
    import("@pages/focus-group/focusGroup/participants")
);
const Interviews = React.lazy(() => import("@pages/interviews"));
const InterviewNew = React.lazy(() => import("@pages/interviews/new"));
const InterviewDetail = React.lazy(() => import("@pages/interviews/interview"));
const SurveySeeder = React.lazy(() =>
    import("@pages/survey/seeder/SurveySeederButton")
);
const TaleScanDashboard = React.lazy(() =>
    import("@pages/survey/new/tale-scan/TaleScanDashboard")
);
const TaleScanDomains = React.lazy(() =>
    import("@pages/survey/new/tale-scan/TaleScanDomains")
);
const SurveyThankYou = React.lazy(() => import("@pages/public/surveys/PublicSurveyThankYou"));

const SurveyPreview = React.lazy(() => import("@pages/survey/surveyId/preview/index"));

const TaleScanConversation = React.lazy(() =>
    import("@pages/survey/new/tale-scan/TaleScanConversation")
);


export const businessRoutes = filterRoutes([
  { path: "/survey/new", element: <SurveyCreationMethod /> },
  { path: "/factures", element: <CompanyInvoices  /> },
  { path: "/factures/:id", element: <InvoiceDetails   /> },
  { path: "/factures/:id/paiement", element: <PaymentPage    /> },
  {
    path: "/survey/:surveyId/edit/:stepName",
    element: <CreateSurveyFromScratch isEditing={true} />,
  },
  { path: "/survey/:surveyId/analytics", element: <SurveyAnalyticsPage /> },
  { path: "/survey/new/scratch", element: <CreateSurveyFromScratch /> },
  { path: "/survey/new/simple", element: <SurveySeeder /> },
  // { path: "/survey/new/simple", element: <CreateSimpleSurvey /> },
  { path: "/survey/new/ai", element: <AISurvey /> },
  {
    path: "/survey/new/tale-scan",
    element: <TaleScanDomains basePath="/survey/new/tale-scan" />,
  },
  {
    path: "/survey/new/tale-scan/:domainId",
    element: (
        <TaleScanDashboard basePath="/survey/new/tale-scan" problems={taleScanProblems} />
    ),
  },
  { path: "/focus-group/new", element: <FocusGroupNew/> },
  { path: "/focus-group/:focusGroupID/participants", element: <FocusGroupParticipants/> },
  { path: "/interviews", element: <Interviews/> },
  { path: "/interviews/new", element: <InterviewNew/> },
  { path: "/interviews/:interviewID", element: <InterviewDetail/> },
  { path: "/reports", element: <Reports/> },
  { path: "/BI/Dashboard", element: <BIAnalysisPage/> },
  { path: "/survey/:surveyId/preview", element: <SurveyPreview /> },
  {
    path: "/survey/new/tale-scan/:domainId/:problemId/chat",
    element: <TaleScanConversation basePath="/survey/new/tale-scan" />,
  },  {
    caseSensitive: true,
    path: "/survey/:surveyId/completion",
    element: <SurveyThankYou />,
  }
], "business");